import { render, staticRenderFns } from "./OrderDetailPop.vue?vue&type=template&id=5f2e4ab8&"
import script from "./OrderDetailPop.vue?vue&type=script&lang=js&"
export * from "./OrderDetailPop.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailPop.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports